import React, { useState } from 'react'
import moment from 'moment';
import { currencyFormatter, customNumberFormatString, customThousandSeparatorDot, getDataById, getFileType, getNameUrl, isFileUrl, isImageUrl } from '../../../functions/general';
import { Pipeline, SimplePipeline } from '../../../interfaces/Pipeline';
import { UserModel } from '../../../app/modules/auth/models/UserModel';
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers';
import { useIntl } from 'react-intl';
import AttachmentViewModal from '../../Shared/AttachmentViewModal';
import { SimpleMerchant } from '../../../interfaces/Merchant';
import { SimpleMeeting } from '../../../interfaces/Meeting';
import { SimpleProduct } from '../../../interfaces/Product';

interface CustomField {
    status: string;
    type: string;
    value: any;
}

interface RenderCustomFieldMasterlogProps {
    row: {
        custom_field: CustomField[];
    };
    simplePipelines: SimplePipeline[];
    simpleMerchants: SimpleMerchant[];
    simpleProducts: SimpleProduct[];
    meetings: SimpleMeeting[];
    users: any[];
    user: UserModel;
}

const RenderCustomFieldMasterlog: React.FC<RenderCustomFieldMasterlogProps> = ({
    row,
    simplePipelines,
    simpleMerchants,
    simpleProducts,
    meetings,
    users,
    user
}) => {
    const intl = useIntl();
    const [modalData, setModalData] = useState<{
        show: boolean;
        title: string;
        url: string | string[];
    }>({
        show: false,
        title: '',
        url: ''
    });

    const handleOpenModal = (title: string, url: string | string[]) => {
        setModalData({
            show: true,
            title,
            url
        });
    };

    const handleCloseModal = () => {
        setModalData({
            show: false,
            title: '',
            url: ''
        });
    };

    const renderFieldValue = (field: CustomField) => {
        let fieldValue = field.value;

        if (field.type === 'pipeline') {
            if (simplePipelines) {
                const pipelineData = getDataById(field.value, simplePipelines);
                if (pipelineData) {
                    fieldValue = `${pipelineData.name} / ${pipelineData.nominal} / ${moment(pipelineData.dateCreated).format('DD MMM YYYY')}`;
                }
            }
        }
        else if (field.type === 'merchant') {
            if (simpleMerchants) {
                if (Array.isArray(field.value) && field.value.length > 0) {
                    const merchantNames = field.value.map(merchantId => {
                        const merchantData = getDataById(merchantId, simpleMerchants);
                        return merchantData ? merchantData.name : '';
                    }).filter(name => name);

                    fieldValue = merchantNames.length > 0 ? merchantNames.join(', ') : '-';
                } else {
                    fieldValue = '-';
                }
            }
        }
        else if (field.type === 'meeting') {
            if (meetings) {
                if (Array.isArray(field.value) && field.value.length > 0) {
                    const meetingDetails = field.value.map(meetingId => {
                        const meetingData = getDataById(meetingId, meetings);
                        return meetingData ?
                            `${meetingData.name} / ${moment(meetingData.dateMeet).format('DD MMM YYYY')} / ${meetingData.meetingStatus}`
                            : '';
                    }).filter(detail => detail);

                    fieldValue = meetingDetails.length > 0 ? meetingDetails.join(', ') : '-';
                } else {
                    fieldValue = '-';
                }
            }
        }
        else if (field.type === 'user') {
            if (users) {
                if (Array.isArray(field.value) && field.value.length > 0) {
                    const userNames = field.value.map((userId: any) => {
                        const userData = getDataById(userId, users);
                        return userData ? userData.name : '';
                    }).filter(name => name);

                    fieldValue = userNames.length > 0 ? userNames.join(', ') : '-';
                } else {
                    fieldValue = '-';
                }
            } else {
                fieldValue = '-';
            }
        }
        else if (field.type === 'date') {
            fieldValue = field.value && field.value !== '-' ? moment(field.value).format('DD MMM YYYY') : '-';
        }
        else if (field.type === 'time') {
            fieldValue = field.value && field.value !== '-' ? moment(field.value).format('HH:mm') : '-';
        }
        else if (field.type === 'multiple' || field.type === 'multipleOption' || field.type === 'option' || field.type === 'text' || field.type === 'pipeline_invoice' || field.type === 'phone') {
            fieldValue = Array.isArray(field.value) ? field.value.join(', ') : field.value;
        }
        else if (field.type === 'serial') {
            fieldValue = Array.isArray(field.value) ? field.value.join('') : field.value;
        }
        else if (field.type === 'number') {
            fieldValue = customThousandSeparatorDot(field.value as unknown as number);
        }
        else if (field.type === 'link') {
            fieldValue = (
                <a href={field.value} rel="noreferrer" target="_blank">
                    {field.value}
                </a>
            );
        }
        else if (field.type === 'image') {
            if (field.value) {
                fieldValue = (
                    <button
                        className="btn btn-sm btn-light-primary"
                        onClick={() => handleOpenModal(field.status, field.value)}
                    >
                        Lihat
                    </button>
                );
            } else {
                fieldValue = '-';
            }
        }
        else if (field.type === 'file') {
            if (field.value) {
                fieldValue = (
                    <button
                        className="btn btn-sm btn-light-primary"
                        onClick={() => handleOpenModal(field.status, field.value)}
                    >
                        Lihat
                    </button>
                );
            } else {
                fieldValue = '-';
            }
        }
        else if (field.type === 'images') {
            if (field.value && Array.isArray(field.value) && field.value.length > 0) {
                fieldValue = (
                    <button
                        className="btn btn-sm btn-light-primary"
                        onClick={() => handleOpenModal(field.status, field.value)}
                    >
                        Lihat
                    </button>
                );
            } else {
                fieldValue = '-';
            }
        }
        else if (field.type === 'files') {
            if (field.value && Array.isArray(field.value) && field.value.length > 0) {
                fieldValue = (
                    <button
                        className="btn btn-sm btn-light-primary"
                        onClick={() => handleOpenModal(field.status, field.value)}
                    >
                        Lihat
                    </button>
                );
            } else {
                fieldValue = '-';
            }
        }
        else if (field.type === 'dateTimeRange') {
            if (Array.isArray(field.value)) {
                fieldValue = field.value.map(date => moment(date).format('DD MMM YYYY HH:mm')).join(' - ');
            }
        } else if (field.type === 'product') {
            if (simpleProducts) {
                if (Array.isArray(field.value) && field.value.length > 0) {
                    const productNames = field.value.map(productId => {
                        const productData = getDataById(productId, simpleProducts);
                        return productData ? productData.name : '';
                    }).filter(name => name);

                    fieldValue = productNames.length > 0 ? productNames.join(', ') : '-';
                } else {
                    fieldValue = '-';
                }
            }
        }
        else {
            fieldValue = field.value || '-';
        }

        return fieldValue;
    };

    return (
        <>
            <ul className="list-unstyled mt-2">
                {row.custom_field.map((field: CustomField, index: number) => {
                    const fieldValue = renderFieldValue(field);

                    return (
                        <li key={index} className="mb-1">
                            <span className="fw-normal">{field.status}:</span>{' '}
                            <span className="fw-bold">{fieldValue}</span>
                        </li>
                    );
                })}
            </ul>
            {modalData.show && (
                <AttachmentViewModal
                    show={modalData.show}
                    title={modalData.title}
                    url={modalData.url}
                    onClose={handleCloseModal}
                />
            )}
        </>
    );
}

export default RenderCustomFieldMasterlog;